import { useCallback } from 'react'

import { usePostHog } from '@/plugins/posthog'
import { useHighlight } from '@/plugins/highlight'
import { useIntercom } from '@/plugins/intercom'

import { useAuthContext } from './useAuthContext'

export const useLogOut = () => {
  const { signOut } = useAuthContext()

  const posthog = usePostHog()

  const highlight = useHighlight()

  const intercom = useIntercom()

  return useCallback(async () => {
    posthog?.reset(true)

    highlight?.reset()

    intercom?.reset()

    await signOut()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
